module.exports = __webpack_public_path__ + "img/badge_EN.5516d9c5.png";